import React from 'react';

import CreateBookmarkButton from './Buttons/CreateBookmarkButton'

type ViewHeaderProps = {
    title: string
}

export default function(props: ViewHeaderProps) {
    const title = props.title

    return (
        <div className="view-header view-header-sticky">
            <div>
                <h2>{title}</h2>
            </div>
            {/* ViewHeader actions */}
            <div>
                {CreateBookmarkButton()}
            </div>
        </div>

    )
}